import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { ScheduledDeliveryInput } from '@/models/scheduledDelivery';

export const createScheduledDelivery = async ({
  callerId,
  storeTitle,
  storeGroup,
  estimate,
  orderOptions,
  scheduledDelivery,
  preferredPhoneNumber,
  clientName,
}: ScheduledDeliveryInput): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation CreateScheduledDelivery(
        $callerId: String!
        $storeTitle: String!
        $storeGroup: StoreGroupInput!
        $estimate: EstimateInput!
        $orderOptions: OrderOptionsInput!
        $scheduledDelivery: ScheduledDeliveryCreateInput!
        $preferredPhoneNumber: String
        $clientName: String
      ) {
        createScheduledDelivery(
          callerId: $callerId
          storeTitle: $storeTitle
          storeGroup: $storeGroup
          estimate: $estimate
          orderOptions: $orderOptions
          scheduledDelivery: $scheduledDelivery
          preferredPhoneNumber: $preferredPhoneNumber
          clientName: $clientName
        )
      }
    `),
    variables: {
      callerId,
      storeTitle,
      storeGroup,
      estimate,
      orderOptions,
      scheduledDelivery,
      preferredPhoneNumber,
      clientName,
    },
  });

  return response.data?.createScheduledDelivery ?? false;
};
